import React from 'react';
import {Grid} from "@material-ui/core";
import {Link} from "react-router-dom";

// images
import iconBg1 from '../../images/remittance_example.png';

import './style.scss';

const Remittance = () => {
    return(
        <Grid className="OurPaystubs">
            <Grid className="container" container alignItems="center" spacing={4}>
                <Grid item xs={12} md={7}>
                    <Grid className="OurPaystubsContent">
                        <div className="dstudioItem">
                            <img src={iconBg1} alt=""/>
                        </div>                    
                    </Grid>
                </Grid>
                <Grid item xs={12} md={5}>
                    <Grid className="textContent">
                        <strong>Remittance</strong>
                        <h4>More Information For You</h4>
                        <p>Along with your pay stub, you’ll receive a full remittance summary outlining the key details from your paystub for record-keeping purposes. On top of that, we’ll offer links to important CRA pages regarding remittance and everything you need to know</p>
                        <Link to="/about-us" className="cBtn">Create a Paystub</Link>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
};

export default Remittance;